/* eslint-disable no-unused-vars */
import Types from "./types";
import { LeadServiceJava } from "../../../service/lead-service-java-api";
import { setMobile } from "../../configuration/actions";
import { parseTransactionDetails, getUpdatedPriceDiscovery } from "./selector";
import { carConsumerService } from "../../../service/car-consumer-gateway-api";
import { getCombinedDiyDetails } from "../post-inspection-diy-container/actions";
import { NewCarCmsServiceApi } from "../../../service/new-car-cms-service";
import { NUMBER } from "../../../constants/app-constants";
import { setPageLoading } from "../car-animation-loader/actions";
import { FAQ_CODE, HOLDBACK_TYPES_FAQS } from "./constant";

const setErrorStatus = (hasError) => ({
    type: Types.SET_ERROR_STATUS,
    hasError
});

const setPickupDetail = (detail) => ({
    type: Types.SET_PICKUP_DETAIL,
    detail
});

const setLoanDetail = (detail) => ({
    type: Types.SET_LOAN_DETAIL,
    detail
});

const setPickupSlot = (slot) => ({
    type: Types.SET_PICKUP_SLOT,
    slot
});

const setCampaginPrice = (campaignRes) => ({
    type: Types.SET_CAMPAGIN_PRICE,
    data: campaignRes
});

const getPickupDocuments = (data) => ({
    type: Types.GET_PICKUP_DOCUMENTS,
    data
});

const setInspectionResponse = (data) => ({
    type: Types.SET_INSPECTION_RESPONSE,
    data
});

const setPriceDiscovery = (priceDiscovery) => ({
    type: Types.SET_PRICE_DISCOVERY,
    priceDiscovery
});

const setPostTokenDocuments = (postTokenDocuments) => ({
    type: Types.SET_POST_TOKEN_DOCUMENTS,
    postTokenDocuments
});

const setCurrentGaEventDetails = (gaEventDetails) => ({
    type: Types.SET_CURRENT_GA_EVENT_DETAILS,
    gaEventDetails
});

const setDiyDetails = (data) => ({
    type: Types.SET_DIY_DETAILS,
    data
});

const setKmsDriven = (kmsDriven) => ({
    type: Types.SET_KMS_DRIVEN,
    kmsDriven
});

const setScreenDetails = (details) => ({
    type: Types.SET_SCREEN_DETAILS,
    details
});

const setActiveTab = (activeTab) => ({
    type: Types.SET_ACTIVE_TAB,
    activeTab
});

const setDiyIntent = (status) => ({
    type: Types.SET_DIY_INTENT,
    status
});

const setPriceBreakup = (data) => ({
    type: Types.SET_PRICE_BREAKUP,
    data
});

const setSelfNegoDetails = (data) => ({
    type: Types.SET_SELF_NEGO_DETAILS,
    data
});

const setHammerSwipe = (enable) => ({
    type: Types.SET_HAMMER_SWIPE,
    enable
});

const setCarHandoverDetails = (details) => ({
    type: Types.SET_CAR_HANDOVER_DETAILS,
    details
});
const updateImpressions = (impression) => ({
    type: Types.SET_UPDATED_IMPRESSIONS,
    impression
});

const setSecondaryPhone = (maskedSecondaryPhone) => ({
    type: Types.SET_SECONDARY_PHONE,
    maskedSecondaryPhone
});

const setCarHealth = (data) => ({
    type: Types.SET_CAR_HEALTH,
    data
});

const resetCarHealth = (data) => ({
    type: Types.RESET_CAR_HEALTH,
    data
});

const fetchInspectionDetails = (token, isLoadingRequired = true) => (dispatch) => {
    return new Promise((resolve, reject) => {
        if (isLoadingRequired) {
            dispatch({type: Types.SET_PAGE_LOADING, pageLoading: true });
        }
        carConsumerService.fetchInspectionDetails(token).then(response => {
            dispatch(setInspectionResponse(response.data));
            resolve(response.data);
            dispatch(setErrorStatus(false));
        }).catch(error => {
            reject(error);
            dispatch(setErrorStatus(true));
        }).finally(() => {
            dispatch({type: Types.SET_PAGE_LOADING, pageLoading: false });
        });
    });
};

const fetchCarDetails = (token) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({type: Types.SET_PAGE_LOADING, pageLoading: true });

        LeadServiceJava.fetchLeadDetails(token)
            .then((response) => {
                const leadRes  = response.data.detail;
                dispatch({
                    type: Types.SET_CAR_DETAILS_RESPONSE, data: leadRes
                });
                dispatch(setMobile(leadRes.phone));
                resolve();
            }).catch(error => {
                reject(error);
            }).finally(() => {
                dispatch({type: Types.SET_PAGE_LOADING, pageLoading: false });
            });
    });
};

const fetchInspectionDetailsViaLeadToken = (token) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({type: Types.SET_PAGE_LOADING, pageLoading: true });
        carConsumerService.fetchInspectionDetailsViaLeadToken(token).then(response => {
            dispatch(setInspectionResponse(response.data));
            resolve(response.data);
            dispatch(setErrorStatus(false));
        }).catch(error => {
            reject(error);
            dispatch(setErrorStatus(true));
        }).finally(() => {
            dispatch({type: Types.SET_PAGE_LOADING, pageLoading: false });
        });
    });
};

const fetchLoginDetails = (token, isLoadingRequired = true) => (dispatch) => {
    return new Promise((resolve, reject) => {
        if (isLoadingRequired) {
            dispatch({type: Types.SET_PAGE_LOADING, pageLoading: true });
        }
        carConsumerService.fetchLoginDetails(token).then(response => {
            resolve(response.data);
            dispatch(setErrorStatus(false));
        }).catch(error => {
            reject(error);
            dispatch(setErrorStatus(true));
        }).finally(() => {
            dispatch({type: Types.SET_PAGE_LOADING, pageLoading: false });
        });
    });
};

const fetchLoginDetailsViaLeadToken = (token) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({type: Types.SET_PAGE_LOADING, pageLoading: true });
        carConsumerService.fetchLoginDetailsViaLeadToken(token).then(response => {
            resolve(response.data);
            dispatch(setErrorStatus(false));
        }).catch(error => {
            reject(error);
            dispatch(setErrorStatus(true));
        }).finally(() => {
            dispatch({type: Types.SET_PAGE_LOADING, pageLoading: false });
        });
    });
};

const setInspectionDate = (selectedInspectionDate) => ({
    type: Types.SET_INSPECTION_DATE,
    selectedInspectionDate
});

const setInspectionTime = (selectedInspectionTime) => ({
    type: Types.SET_INSPECTION_TIME,
    selectedInspectionTime
});

const sendOtp = (token) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.sendOtp(token).then(() => {
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
};
const verifyOtp = (token, params) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.verifyOtp(token, params).then((response) => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

const fetchCjDetail = (appointmentId) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.fetchCjDetails(appointmentId)
            .then(response => {
                dispatch({
                    type: Types.SET_CJ_DETAIL, data: response.data.detail
                });
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const fetchLoanDetails = (appointmentId) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.fetchLoanDetails(appointmentId)
            .then(response => {
                dispatch(setLoanDetail(response.data));
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const fetchVirtualDetails = (token) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.fetchVirtualNumber(token)
            .then(response => {
                dispatch({
                    type: Types.SET_VIRTUAL_DETAILS, data: response.data
                });
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const fetchVirtualNumberWithAppointmentId = (token) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.fetchVirtualNumberWithAppointmentId(token)
            .then(response => {
                dispatch({
                    type: Types.SET_VIRTUAL_DETAILS, data: response.data
                });
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const uploadDocument = (token, params) => () => {
    return new Promise((resolve) => {
        carConsumerService.uploadDocument(token, params).then(data => {
            resolve(data);
        });
    });
};

const uploadDocumentToDMS = (params, headerData) => () => {
    return new Promise((resolve, reject) => {
        carConsumerService.uploadDocumentToDMS(params, headerData).then(data => {
            resolve(data);
        }).catch(error => {
            reject(error);
        });
    });
};

const getPurchaseRequestDetails = (token) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.purchaseRequest(token).then(data => {
            dispatch({
                type: Types.GET_PURCHASE_TOKEN, purchaseToken: data.data
            });
            resolve(data.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const diyBankVerify = (token, params) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.diyBankVerify(token, params).then(data => {
            dispatch({
                type: Types.SET_BANK_VERIFICATION_DATA, bankVerification: data.data
            });
            resolve(data.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const cafOtpVerify = (params, payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.cafOtpVerify(params, payload).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const initiatePRProcess = (token, payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.initiatePRProcess(token, payload).then(response => {
            window.setTimeout(() => {
                dispatch(setPriceDiscovery(response.data.priceDiscovery));
            }, NUMBER.TWO_THOUSAND);
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const createPurchaseRequest = (token) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.createPurchaseRequest(token).then(response => {
            carConsumerService.diyPaymentApprovalProcess(token).then(documents => {
                dispatch(setInspectionResponse(response.data));
                dispatch(setPostTokenDocuments(documents.data));
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        }).catch(error => {
            reject(error);
        });
    });
};

const createPurchaseRequestV2 = (token, payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.createPurchaseRequestV2(token, payload).then(response => {
            carConsumerService.diyPaymentApprovalProcess(token).then(documents => {
                dispatch(setInspectionResponse(response.data));
                dispatch(setPostTokenDocuments(documents.data));
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        }).catch(error => {
            reject(error);
        });
    });
};

const fetchRequiredDocumentList = (appId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.fetchRequiredDocumentList(appId).then(response => {
            dispatch({
                type: Types.SET_REQUIRED_DOCUMENTS_LIST, requiredDocumentList: response.data
            });
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const dmsLogin = (appId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.dmsLogin(appId).then(response => {
            dispatch({
                type: Types.SET_DMS_LOGIN_DATA, dmsLoginData: response.data.data
            });
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const cancelPickup = (token, payload) => () => {
    return new Promise((resolve, reject) => {
        carConsumerService.cancelPickup(token, payload).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const getPickupSlots = (token) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getPickupSlot(token).then(response => {
            dispatch(setPickupSlot(response));
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

const getPickupDetail = (token) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getPickupDetail(token).then(response => {
            dispatch(setPickupDetail(response.data));
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const schedulePickup = (token, payload) => () => {
    return new Promise((resolve, reject) => {
        carConsumerService.schedulePickup(token, payload).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

const pickupReschedule = (token, payload) => () => {
    return new Promise((resolve, reject) => {
        carConsumerService.pickupReschedule(token, payload).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

const dowloadConsentLetter = (token) => () => {
    return new Promise((resolve, reject) => {
        carConsumerService.dowloadConsentLetter(token).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const getCampaginPrice = (appointmentId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getCampaginPrice(appointmentId).then(response => {
            dispatch(setCampaginPrice(response.data.detail));
            resolve(response.data.detail);
        }).catch(error => {
            reject(error);
        });
    });
};

const postUserResponse = (token, payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.postUserResponse(token, payload).then((response) => {
            carConsumerService.fetchInspectionDetails(response.data.token).then(inspectionResponse => {
                const responseCopy = {...inspectionResponse.data};
                const { priceDiscovery, isExpired, auction } = responseCopy;
                const { customerOcb, auctionType } = auction || {};
                const newPriceDiscovery = getUpdatedPriceDiscovery({priceDiscovery, customerOcb, isExpired, auctionType});
                responseCopy.priceDiscovery = newPriceDiscovery;
                dispatch(setInspectionResponse(responseCopy));
                resolve();
                dispatch(setErrorStatus(false));
            }).catch(error => {
                reject(error);
                dispatch(setErrorStatus(true));
            });
        }).catch(error => {
            reject(error);
        });
    });
};

const getLeadDetail = (token) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.fetchLeadDetails(token)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const fetchGeoDetailsForPickup = (params) => dispatch =>  {
    return new Promise((resolve, reject) => {
        carConsumerService.fetchGeoDetails(params)
            .then(response => {
                resolve(response.data.detail);
            }).catch(error => {
                reject(error);
            });
    });
};

const pickupDocuments = (appoinntmentId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.getPickupDocuments(appoinntmentId)
            .then((response) => {
                dispatch(getPickupDocuments(response.data));
                resolve(response.data);
            }).catch(error => {
                if (error.code === "C2BCGS433") {
                    const data = {
                        pickupCancelled: true
                    };
                    dispatch(getPickupDocuments(data));
                }
                reject(error);
            });
    });
};

const fetchCarDetailsForPickup = (leadToken, secureToken) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch({type: Types.SET_PAGE_LOADING, pageLoading: true });
        LeadServiceJava.getAppointmentDetailsByTokenProtected(leadToken, secureToken, false).then(response => {
            resolve({ detail: response });
            dispatch({
                type: Types.SET_CAR_DETAILS_RESPONSE, data: { detail: response }
            });
        }).catch(error => {
            reject(error);
        }).finally(() => {
            dispatch({type: Types.SET_PAGE_LOADING, pageLoading: false });
        });
    });
};
const verifyEkycDocument = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.verifyEkycDocument(token, payload).then((response) => {
            dispatch(setInspectionResponse(response.data));
            resolve();
            dispatch(setErrorStatus(false));
        }).catch(error => {
            reject(error);
        });
    });
};

const submitForQc = (appoinntmentId, payload) => () => {
    return new Promise((resolve, reject) => {
        carConsumerService.submitForQc(appoinntmentId, payload)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const cancelDriverPickup = (appoinntmentId, payload) => () => {
    return new Promise((resolve, reject) => {
        carConsumerService.cancelDriverPickup(appoinntmentId, payload)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const proceedWithPickup = (appoinntmentId, payload) => () => {
    return new Promise((resolve, reject) => {
        carConsumerService.proceedWithPickup(appoinntmentId, payload)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const pickupDocumentsWithToken = (token) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.pickupDocument(token)
            .then((response) => {
                dispatch(getPickupDocuments(response.data));
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const fetchTokenProcessedDetails = (token, paymentType) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.fetchTokenProcessedDetails(token, paymentType)
            .then((response) => {
                resolve(parseTransactionDetails(response.data, paymentType));
            }).catch(error => {
                reject(error);
            });
    });
};

const diyPaymentApprovalProcess = (token, loanStatus, saveInRedux = true) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.diyPaymentApprovalProcess(token, loanStatus).then(response => {
            if (saveInRedux)dispatch(setPostTokenDocuments(response.data));
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const fetchIfscDetails = (payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.fetchIfscDetails(payload).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const savePriceView = (token, payload = {}) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.savePriceView(token, payload).then(() => {
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
};

const saveDnpDecision = (token, payload = {}) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.saveDnpDecision(token, payload).then(() => {
            carConsumerService.fetchInspectionDetails(token).then(inspectionResponse => {
                const responseCopy = {...inspectionResponse.data};
                const { priceDiscovery, isExpired, auction } = responseCopy;
                const { customerOcb, auctionType } = auction || {};
                const newPriceDiscovery = getUpdatedPriceDiscovery({priceDiscovery, customerOcb, isExpired, auctionType});
                responseCopy.priceDiscovery = newPriceDiscovery;
                window.setTimeout(() => {
                    dispatch(setInspectionResponse(responseCopy));
                }, NUMBER.TWO_THOUSAND);
                dispatch(setErrorStatus(false));
                carConsumerService.getAuctionDetails(token)
                    .then(() => {
                        resolve();
                    }).catch(error => {
                        reject(error);
                    });
            });
        }).catch(error => {
            reject(error);
        });
    });
};

const resetAuction = (token, payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.resetAuction(token, payload).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const createNewPurchaseRequest = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.createNewPurchaseRequest(token, payload).then(response => {
            dispatch(setInspectionResponse(response.data));
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const getDsiEligibility = (token) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.getDsiEligibility(token).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const getDiyIntent = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.getDiyIntent(token, payload).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const submitCibilConsent = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.submitCibilConsent(token, payload).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const submitCibilNumber = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.submitCibilNumber(token, payload).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const saveSelfNegoExpectedPrice = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.saveSelfNegoExpectedPrice(token, payload).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const submitBankMisMatchReason = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.submitBankMisMatchReason(token, payload).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const verifyDocumentUpload = (token, payload, version) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.verifyDocumentUpload(token, payload, version).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const getPriceBreakup = (token, parameter) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.priceBreakup(token, parameter)
            .then((response) => {
                dispatch(setPriceBreakup(response.data));
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const getUpdatedDiyDetails = (token, loaderTitle) => dispatch => {
    dispatch(setPageLoading(true, loaderTitle));
    return new Promise((resolve, reject) => {
        window.setTimeout(() => {
            carConsumerService.fetchInspectionDetails(token).then((res) => {
                dispatch(getCombinedDiyDetails(res.data)).then((response) => {
                    dispatch(setDiyDetails(response));
                    dispatch(setPageLoading(false));
                    resolve(response);
                });
            }).catch(error => {
                reject(error);
                dispatch(setPageLoading(false));
            });
        }, NUMBER.TEN_THOUSAND);
    });
};

const submitRaCallback = (token, parameter) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.submitRaCallback(token, parameter)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const submitLoanDetails = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.submitLoanDetails(token, payload)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const submitLeadMonTransactionRequest = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.submitLeadMonTransactionRequest(token, payload)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const getReportUrl = (reportToken) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.getReportUrl(reportToken)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const stopAuction = (token) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.stopAuction(token)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const sendUserSecondaryPhone = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.sendUserSecondaryPhone(token, payload)
            .then((response) => {
                dispatch(setSecondaryPhone(response.data && response.data.maskedSecondaryPhone));
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const selectFlowOffline = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.selectFlowOffline(token, payload)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const setOfflineRequestedPrice = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.setOfflineRequestedPrice(token, payload)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const setIsFetched = (isFetched) => dispatch => {
    dispatch({
        type: Types.SET_IS_FETCHED,
        isFetched
    });
};

const getPartyPeshifaqs = (payment) => dispatch => {
    const result = [];
    // eslint-disable-next-line consistent-return
    const promises = payment.map((item) => {
        if (item.amount && HOLDBACK_TYPES_FAQS.includes(item.purpose || item.label)) {
            return new Promise((resolve, reject) => {
                NewCarCmsServiceApi
                    .fetchfaqs(FAQ_CODE[item.purpose || item.label])
                    .then((response) => {
                        const { data } = response.data || {};
                        result.push(...data);
                        resolve(...result, ...data);
                    })
                    .catch((error) => {reject(error); });
            });
        }
    });

    return Promise.all(promises).then((res) => {
        return Promise.resolve(result);
    });
};

const fetchOffersDetailsCms = () => disptach => {
    return new Promise((resolve, reject) => {
        NewCarCmsServiceApi.getOfferDetails({
            bannerName: ["Offer"]
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const getPartyPeshiVideo = (token) => disptach => {
    return new Promise((resolve, reject) => {
        carConsumerService.getPartyPeshiVideo(token).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const rejectDnpOffer = (dnpPriceConfirmationEnabled) => ({
    type: Types.SET_DNP_OFFER,
    dnpPriceConfirmationEnabled
});

const qcAutopilotSendOtp = (payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.sendQcAutoPilotOtp(payload)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const qcAutopilotVerifyOtp = (payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.verifyQcAutoPilotOtp(payload)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const fetchKavachBanner = (token) => (dispatch) => {
    return new Promise((resolve, reject) => {
        carConsumerService.fetchKavachBanner(token).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

export {
    sendOtp,
    verifyOtp,
    schedulePickup,
    getPickupDetail,
    getPickupSlots,
    getLeadDetail,
    postUserResponse,
    cafOtpVerify,
    getCampaginPrice,
    fetchInspectionDetails,
    fetchCarDetails,
    pickupReschedule,
    setPageLoading,
    setErrorStatus,
    fetchInspectionDetailsViaLeadToken,
    setInspectionDate,
    setInspectionTime,
    fetchCjDetail,
    fetchVirtualDetails,
    uploadDocument,
    getPurchaseRequestDetails,
    diyBankVerify,
    initiatePRProcess,
    createPurchaseRequest,
    fetchRequiredDocumentList,
    uploadDocumentToDMS,
    dmsLogin,
    cancelPickup,
    dowloadConsentLetter,
    fetchGeoDetailsForPickup,
    pickupDocuments,
    submitForQc,
    fetchCarDetailsForPickup,
    cancelDriverPickup,
    proceedWithPickup,
    fetchVirtualNumberWithAppointmentId,
    pickupDocumentsWithToken,
    verifyEkycDocument,
    diyPaymentApprovalProcess,
    setInspectionResponse,
    getPickupDocuments,
    fetchTokenProcessedDetails,
    setPostTokenDocuments,
    setCurrentGaEventDetails,
    fetchIfscDetails,
    savePriceView,
    createPurchaseRequestV2,
    setDiyDetails,
    saveDnpDecision,
    setKmsDriven,
    setScreenDetails,
    resetAuction,
    createNewPurchaseRequest,
    setActiveTab,
    getDsiEligibility,
    getDiyIntent,
    setDiyIntent,
    submitCibilConsent,
    submitCibilNumber,
    verifyDocumentUpload,
    getPriceBreakup,
    getUpdatedDiyDetails,
    saveSelfNegoExpectedPrice,
    setSelfNegoDetails,
    submitBankMisMatchReason,
    setHammerSwipe,
    submitRaCallback,
    fetchLoanDetails,
    submitLoanDetails,
    setCarHandoverDetails,
    submitLeadMonTransactionRequest,
    updateImpressions,
    getReportUrl,
    stopAuction,
    sendUserSecondaryPhone,
    rejectDnpOffer,
    selectFlowOffline,
    setOfflineRequestedPrice,
    getPartyPeshifaqs,
    fetchOffersDetailsCms,
    setIsFetched,
    getPartyPeshiVideo,
    fetchLoginDetailsViaLeadToken,
    fetchLoginDetails,
    qcAutopilotSendOtp,
    qcAutopilotVerifyOtp,
    setCarHealth,
    resetCarHealth,
    fetchKavachBanner

};
